import React, { useEffect, useRef, useState } from 'react';
import Input from '@components/Input';
import useInput from '@hooks/useInput';
import Icon from '@components/Icon';
import Button from '@components/Button';
import ImgSatellite from './img-satellite.png';
import ImgNormal from './img-normal.png';
import { stEditorAmap } from '../STAMap';

function MapEditorSearch() {
  const input = useInput<HTMLInputElement>();
  const searchDrop = useRef<HTMLDivElement>(null);
  const [satelliteView, setSatelliteView] = useState(false);

  const handleChangeLayers = () => {
    setSatelliteView((prev) => !prev);
    if (satelliteView) {
      stEditorAmap.changeLayer(0);
    } else {
      stEditorAmap.changeLayer(1);
    }
  };

  useEffect(() => {
    // @ts-ignore
    AMap.plugin(['AMap.PlaceSearch', 'AMap.AutoComplete'], () => {
      // @ts-ignore
      const auto = new AMap.AutoComplete({
        input: input.ref.current,
        output: searchDrop.current,
      });
      // @ts-ignore
      const placeSearch = new AMap.PlaceSearch();
      // @ts-ignore
      const select = (e) => {
        placeSearch.setCity(e.poi.adcode);
        // @ts-ignore
        placeSearch.search(e.poi.name, (_, results) => {
          const location = results?.poiList?.pois?.[0]?.location;
          if (location) {
            stEditorAmap.setCenter({
              lng: location.getLng(),
              lat: location.getLat(),
              zoom: 18,
            });
          }
        });
      };
      auto.on('select', select);
    });
  }, []);

  return (
    <div className="absolute top-20 left-20 flex items-center">
      <div className="relative h-30 w-300">
        <Input
          className="h-30 w-full"
          placeholder="请输入地点名称搜索"
          {...input.bind}
        />
        <div
          className="absolute z-30 mt-5 w-full select-none overflow-hidden rounded-xs bg-white text-black focus:outline-none"
          ref={searchDrop}
        />
      </div>
      <Button className="ml-10" scheme="white" onClick={handleChangeLayers}>
        <Icon src={satelliteView ? ImgNormal : ImgSatellite} className="mr-5" />
        {satelliteView ? '切换普通地图' : '切换卫星地图'}
      </Button>
    </div>
  );
}

export default MapEditorSearch;
